export const isVencidaOrComPedido = (type, item) => {
  if (
    type === 'c' &&
    item?.Expirado &&
    item?.DescricaoSituacao !== 'Cotação com Pedido'
  ) {
    return true
  } else if (type === 'c' && item?.DescricaoSituacao === 'Cotação com Pedido') {
    return true
  } else if (
    type !== 'c' &&
    item?.Expirado &&
    item?.DescricaoSituacao !== 'Negociação com Pedido'
  ) {
    return true
  } else if (
    type !== 'c' &&
    item?.DescricaoSituacao === 'Negociação com Pedido'
  ) {
    return true
  } else {
    return false
  }
}

export const changeNegociacaoStatus = (status) => {
  let tag = status

  switch (status) {
    case 'Negociação Avaliada':
      tag = 'Avaliada'
      break
    case 'Negociação aguardando avaliação':
      tag = 'Em Avaliação'
      break
    case 'Negociação aguardando conferência':
      tag = 'Em Avaliação'
      break
    case 'Negociação Cancelada':
      tag = 'Cancelada'
      break
    default:
      break
  }

  return tag
}

export const getStatusNegociacao = (item) => {
  if (item?.DescricaoSituacao === 'Negociação Cancelada') {
    return 'Cancelada'
  } else if (
    item?.Expirado &&
    item?.DescricaoSituacao !== 'Negociação com Pedido'
  ) {
    return 'Vencida'
  } else if (item?.DescricaoSituacao === 'Negociação com Pedido') {
    return 'Convertida'
  } else {
    return changeNegociacaoStatus(item?.DescricaoSituacao)
  }
}

export const getStatusCotacao = (item) => {
  if (item?.DescricaoSituacao === 'Cotação Cancelada') {
    return 'Cancelada'
  } else if (
    item?.Expirado &&
    item?.DescricaoSituacao !== 'Cotação com Pedido'
  ) {
    return 'Vencida'
  } else if (item?.DescricaoSituacao === 'Cotação com Pedido') {
    return 'Convertida'
  } else if (
    item?.DescricaoSituacao === 'Cotação' &&
    item?.Expirado === false
  ) {
    return 'Válida'
  } else {
    return item?.DescricaoSituacao
  }
}
